import "@/App.css";
import "./i18n";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Layout } from "./components/layout/Layout";
import { HomePage } from "./pages/HomePage";
import { OpenEnrollmentPage } from "./pages/OpenEnrollmentPage";
import { SpecialEnrollmentPage } from "./pages/SpecialEnrollmentPage";
import { HealthPlansPage } from "./pages/HealthPlansPage";
import { DentalVisionPage } from "./pages/DentalVisionPage";
import { MedicarePage } from "./pages/MedicarePage";
import { ContactPage } from "./pages/ContactPage";
import { SmallBusinessPage } from "./pages/SmallBusinessPage";
import { CommunityOrganizationsPage } from "./pages/CommunityOrganizationsPage";
import { AboutPage } from "./pages/AboutPage";
import { WorkWithUsPage } from "./pages/WorkWithUsPage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { SmsTermsPage } from "./pages/SmsTermsPage";
import { MedicareEnrollmentPage } from "./pages/MedicareEnrollmentPage";
import { PortalApp } from "./portal/PortalApp";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Portal routes - no public Layout */}
          <Route path="/portal/*" element={<PortalApp />} />
          
          {/* Public website routes - with Layout */}
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/community-organizations" element={<CommunityOrganizationsPage />} />
                <Route path="/open-enrollment" element={<OpenEnrollmentPage />} />
                <Route path="/special-enrollment" element={<SpecialEnrollmentPage />} />
                <Route path="/health-plans" element={<HealthPlansPage />} />
                <Route path="/dental-vision" element={<DentalVisionPage />} />
                <Route path="/medicare" element={<MedicarePage />} />
                <Route path="/medicare-enrollment" element={<MedicareEnrollmentPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/small-business" element={<SmallBusinessPage />} />
                <Route path="/work-with-us" element={<WorkWithUsPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/sms-terms" element={<SmsTermsPage />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
